







import BaseComponent from '@/components/base-component.vue';
import { IBusinessUnit } from '@/interfaces/business-units';
import IClient from '@/interfaces/client';
import { getLocalBusinessUnit, getLocalClient } from '@/services/session-data';
import Component from 'vue-class-component';

@Component
export default class ClientInfo extends BaseComponent {

  public unit: IClient;
  public empresa: IBusinessUnit;

  public beforeMount(): void {
    this.getLocalClientNovo();
    this.getLocalBusinessUnitNovo();
  }

  private getLocalClientNovo(): void {
    this.unit = getLocalClient();
  }

  private getLocalBusinessUnitNovo(): void {
    this.empresa = getLocalBusinessUnit();
  }

  private onEmpresaClick(): void {
    this.$emit('trocarEmpresa')
  }
}
